import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteProductPerkMutation = createMutationHook(
  MembershipsCreatorApiClient.deleteProductPerk,
  {
    mutationKey: ['deleteProductPerk'],
  },
)
